import React from 'react';
import UICircleChart, { UICircleChartSegment } from '@/components/shared/UICircleChart';
import './UICircleChartWithLegend.scss';

export interface UICircleChartWithLegendProps {
  segments: UICircleChartSegment[];
  size?: number;
  strokeWidth?: number;
  backgroundColor?: string;
  className?: string;
  legendPosition?: 'left' | 'right' | 'top' | 'bottom';
  gap?: number;
}

const UICircleChartWithLegend: React.FC<UICircleChartWithLegendProps> = ({
                                                                           segments,
                                                                           size = 104,
                                                                           strokeWidth = 16,
                                                                           backgroundColor = '#F4F6F8',
                                                                           className = '',
                                                                           legendPosition = 'left',
                                                                           gap = 32,
                                                                         }) => {
  const isHorizontal = legendPosition === 'left' || legendPosition === 'right';
  const isVertical = legendPosition === 'top' || legendPosition === 'bottom';

  const containerClasses = [
    'UICircleChartWithLegend',
    `UICircleChartWithLegend--${legendPosition}`,
    className,
  ].filter(Boolean).join(' ');

  const containerStyle: React.CSSProperties = {
    gap: `${gap}px`,
  };

  return (
    <div className={containerClasses} style={containerStyle}>
      {/* Legend (before chart for left/top position) */}
      {(legendPosition === 'left' || legendPosition === 'top') && (
        <div className="UICircleChartWithLegend__legend">
          {segments.map((segment, index) => (
            <div key={index} className="UICircleChartWithLegend__legend-item">
              <div
                className="UICircleChartWithLegend__legend-dot"
                style={{ backgroundColor: segment.color }}
              />
              <span className="UICircleChartWithLegend__legend-label">
                {segment.label}
              </span>
              <span className="UICircleChartWithLegend__legend-value">
                {segment.percentage}%
              </span>
            </div>
          ))}
        </div>
      )}

      {/* Chart */}
      <div className="UICircleChartWithLegend__chart">
        <UICircleChart
          segments={segments}
          size={size}
          strokeWidth={strokeWidth}
          backgroundColor={backgroundColor}
        />
      </div>

      {/* Legend (after chart for right/bottom position) */}
      {(legendPosition === 'right' || legendPosition === 'bottom') && (
        <div className="UICircleChartWithLegend__legend">
          {segments.map((segment, index) => (
            <div key={index} className="UICircleChartWithLegend__legend-item">
              <div
                className="UICircleChartWithLegend__legend-dot"
                style={{ backgroundColor: segment.color }}
              />
              <span className="UICircleChartWithLegend__legend-label">
                {segment.label}
              </span>
              <span className="UICircleChartWithLegend__legend-value">
                {segment.percentage}%
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default UICircleChartWithLegend;